// extracted by mini-css-extract-plugin
export default {"labelItem":"JMbvxn0JC8YYQGmYhAkY","labelColor":"ogsHeYfAdlC9GMaV0uwF","labelName":"jagyG3mVoTPyvJKbl5xQ"};